import React from 'react';
import config from 'cityads-v3/config';

import AVAILABLE_LANGUAGES from './availableLanguages';

export function tArray(t, key, WrapComponent, wrapProps) {
  const translations = t(key, { returnObjects: true });

  if (!Array.isArray(translations)) { return null; }

  if (!WrapComponent) {
    return translations;
  }

  return translations.map((item, i) => <WrapComponent {...wrapProps} key={i}>{item}</WrapComponent>)
}

export { AVAILABLE_LANGUAGES };

export const DEFAULT_LANGUAGE = config.DEFAULT_LANGUAGE;
export const DEFAULT_LANGUAGE_ID = 2;

export const AVAILABLE_NAMESPACES = [
  'About',
  'AdsIntegration',
  'AdvertiserMore',
  'AgentCabinet',
  'API',
  'Backurl',
  'BannerRotator',
  'BigData',
  'ConversionPostback',
  'CouponFeed',
  'Dashboard',
  'DomainParking',
  'Finance',
  'FiranoApi',
  'Goods',
  'LinksGenerator',
  'LostOrders',
  'LostOrdersArticle',
  'main',
  'Monitoring',
  'News',
  'Offers',
  'Payments',
  'PaymentsArticle',
  'PowerOfCPA',
  'ProductFeed',
  'PublisherMore',
  'Publisher',
  'Showcases',
  'Statistics',
  'Trackers',
  'Widgets',
  'Welcome',
  'WidgetsArticle',
  'ZaleyCash',
];

export function prepareLanguage(language) {
  return (language || '').split('-')[0];
}
